import React from 'react';

import {
  Box,
  Button,
  styled
} from '@mui/material';
import {
  BaseWidget,
  InitiateReturnModal,
  SendChatMessageModal
} from 'modules';

import { modalUtil } from 'iron-forge-react-modules';
import * as dataService from './dataService';



const RowBox = styled(Box)({
  display: 'flex'
});

const RightBox = styled(RowBox)(({ theme }) => ({
  justifyContent: 'flex-end',
  flex: 1,
  gap: theme.spacing(1)
}));


export interface IProps {
  orderId: string;
}

export const FC: React.FC<IProps> = props => {
  const tuple = dataService.useQuery(props.orderId);
  // const [closeOrderAsCustomer, closeOrderAsCustomerTuple] = dataService.useCloseOrderAsCustomer(props.orderId);

  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers([
    'sendMessage',
    'initiateReturn'
  ]);

  const [returnButtonDisabled, setReturnButtonDisabled] = React.useState(false);



  function handleClickSendMessage() {
    setModalIsOpen('sendMessage', true);
  }

  function handleCloseSendChatMessageModal() {
    setModalIsOpen('sendMessage', false);
  }

  // function handleClickCloseOrder() {
  //   if (window.confirm("Are you sure you want to close this order? This action is irreversible!")) {
  //     closeOrderAsCustomer();
  //   }
  // }

  function handleClickInitiateReturn() {
    if (window.confirm("A return already exists on this order. Are you sure you want to open another?")) {
      setModalIsOpen('initiateReturn', true);
    }
  }

  function handleCloseInitiateReturnModal() {
    setModalIsOpen('initiateReturn', false);
  }



  React.useEffect(
    () => {
      if (!modalType2IsOpen.initiateReturn && returnButtonDisabled) {
        setTimeout(() => {
          setReturnButtonDisabled(false);
        }, 1000);
      }
    },
    [
      modalType2IsOpen.initiateReturn,
      returnButtonDisabled
    ]
  );



  React.useEffect(
    () => {
      if (!returnButtonDisabled) {
        setReturnButtonDisabled(modalType2IsOpen.initiateReturn);
      }
    },
    [
      modalType2IsOpen.initiateReturn,
      returnButtonDisabled
    ]
  );



  return tuple.loading ? null : (
    <>
      <BaseWidget.FC>
        <RowBox>
          <Button
            variant="contained"
            onClick={handleClickSendMessage}>
            Send Message
          </Button>

          <RightBox>
            {/* {tuple.data.canCloseOrder && (
              <Button
                disabled={loading}
                variant="contained"
                onClick={handleClickCloseOrder}>
                Close Order
              </Button>
            )} */}

            {tuple.data.canInitiateReturnAuthorization && (
              <Button
                disabled={returnButtonDisabled}
                variant="contained"
                onClick={handleClickInitiateReturn}>
                Initiate Return
              </Button>
            )}
          </RightBox>
        </RowBox>
      </BaseWidget.FC>

      {modalType2IsOpen.sendMessage && (
        <SendChatMessageModal.FC
          isCustomer
          orderId={props.orderId}
          onClose={handleCloseSendChatMessageModal} />
      )}

      {modalType2IsOpen.initiateReturn && (
        <InitiateReturnModal.FC
          asCustomer
          orderId={props.orderId}
          onClose={handleCloseInitiateReturnModal} />
      )}
    </>
  );
};
